var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"id-list-text"},[_c('p',{staticClass:"typo-body-2 color-black-45"},[_vm._v(_vm._s(_vm.listText))])])}
var staticRenderFns = []

export { render, staticRenderFns }